module.exports = __webpack_public_path__ + "static/media/github.09ff6db3.svg";